export const LogsAssistant = {
    "Logs": {
        items: [
            //Viewing system logs
            {
                heading: 'Viewing system logs',
                permissions: ['System Admin'],
                tags: ['logs'],
                sections: [
                    {
                        description: 'Select the DrData facility',
                        styleAs: 'list',
                    },
                    {
                        description: 'From the menu select <b>Logs</b>',
                        styleAs: 'list',
                    },
                ],
                options: [
                    {
                        option: 'Take me to system logs',
                        action: {
                            type: 'location',
                            value: '/sys-admin/logs',
                            params: { section: 'main' }
                        },

                    },
                ]
            },
        ]
    }
}